// BambiniJO: Gift Reggie (registry / wishlist) pages.
// 1) One "Share" button (phone share sheet: WhatsApp, Instagram… / copy link on computers)
//    instead of the app's Email / Facebook / Twitter / LinkedIn row.
// 2) Arabic: the app has none, so on /ar swap its fixed English phrases (exact matches only).
//    Missing phrase? Add it to AR below.
(() => {
  if (!location.pathname.includes('/apps/giftregistry')) return;
  const isAr = document.documentElement.lang === 'ar';
  const NO_DATE = '31/12/2099';
  const SHARE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="8 8 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M27.67 10.54 L26.76 10.40 L25.77 10.59 L12.25 14.57 L11.40 15.04 L11.07 15.36 L10.72 15.86 L10.47 16.49 L10.41 16.76 L10.47 17.92 L10.83 18.68 L11.26 19.18 L12.03 19.59 L17.49 22.06 L17.82 22.30 L20.75 28.67 L21.44 29.24 L22.07 29.52 L22.62 29.60 L23.41 29.55 L24.10 29.30 L24.54 29.02 L24.98 28.59 L25.31 28.06 L25.80 26.58 L29.59 13.50 L29.53 12.51 L29.12 11.61 L28.71 11.14 L28.32 10.84ZM27.17 12.21 L27.39 12.35 L27.75 12.79 L27.80 13.36 L23.77 27.16 L23.55 27.52 L23.33 27.71 L23.00 27.84 L22.65 27.84 L22.43 27.76 L22.18 27.54 L19.55 21.84 L19.55 21.73 L24.54 16.71 L24.70 16.38 L24.70 16.00 L24.51 15.61 L24.29 15.42 L23.99 15.31 L23.55 15.34 L23.25 15.50 L18.26 20.47 L12.47 17.83 L12.28 17.64 L12.20 17.42 L12.22 16.85 L12.61 16.35 L13.02 16.16 L17.11 15.01 L26.49 12.21Z"/></svg>';   // our Instagram-style share icon (Brand/icons/share.svg)
  const addShare = () => document.querySelectorAll('ul.giftreggie-share-buttons:not([data-bjo])').forEach((ul) => {
    ul.dataset.bjo = '';
    const front = ul.closest('.giftreggie-front');
    const link = front && front.querySelector('.giftreggie-permalink');
    const found = link && ((link.value || link.querySelector('input')?.value || link.textContent).match(/https?:\/\/\S+/) || [])[0];
    const url = found || location.href.split('?')[0];
    const title = (front && front.querySelector('h1,h2,h3')?.textContent.trim()) || document.title;
    const label = isAr ? 'مشاركة' : 'Share';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bjo-registry-share';
    btn.innerHTML = SHARE_ICON + '<span>' + label + '</span>';
    btn.addEventListener('click', async () => {
      if (navigator.share) { try { await navigator.share({ title, url }); } catch (e) {} return; }
      try { await navigator.clipboard.writeText(url); } catch (e) { window.prompt('', url); return; }
      btn.querySelector('span').textContent = isAr ? 'تم نسخ الرابط ✓' : 'Link copied ✓';
      setTimeout(() => { btn.querySelector('span').textContent = label; }, 2000);
    });
    ul.after(btn);
  });
  // Create / edit form: drop "How did you hear about us?" when it has nothing to pick,
  // and put each checkbox on one line with its text.
  // Create / edit form: Co-Registrant stays closed behind a green "Add someone" switch inside the Registrant box;
  // switching it on shows the Co-Registrant box. Opens by itself when a co-registrant name is already saved. (Hamza 2026-10-10)
  const coReg = () => {
    const first = document.querySelector('.giftreggie-front form [name="coregistrant-first"]');
    const box = first && first.closest('.registry-profile-block > span');
    const reg = box && box.parentElement.querySelector(':scope > span:has([name="registrant-first"])');
    if (!box || !reg || box.dataset.bjoCo !== undefined) return;
    box.dataset.bjoCo = '';
    const filled = [...box.querySelectorAll('input:not([type="hidden"])')].some((i) => i.value.trim());
    const sw = document.createElement('label');
    sw.className = 'bjo-switch bjo-coreg-switch';
    sw.innerHTML = '<input type="checkbox"><span class="bjo-switch__track" aria-hidden="true"></span><span class="bjo-switch__label"></span>';
    sw.querySelector('.bjo-switch__label').textContent = isAr ? 'أضف شخصاً آخر للسجل' : 'Add someone to this registry';
    const cb = sw.querySelector('input');
    const set = (on) => { cb.checked = on; box.classList.toggle('bjo-coreg-closed', !on); };
    cb.addEventListener('change', () => { set(cb.checked); if (cb.checked) first.focus(); });
    set(filled);
    reg.appendChild(sw);
  };
  // Create page: "Already have a registry? Click here to manage it." → one short button
  const manageLink = () => {
    const a = document.querySelector('.giftreggie-create .giftreggie-body > p > a:not([data-bjo])');
    if (!a) return;
    a.dataset.bjo = '';
    a.textContent = isAr ? 'لديك سجل؟' : 'Already have one?';
    a.classList.add('bjo-manage-btn');
  };
  // Registry home: the app's "Click here to begin browsing to add products…" link (empty list: .giftreggie-no-products,
  // list with gifts: .giftreggie-browse-add-products at the bottom) → one short charcoal "Browse & Add" button
  const browseBtn = () => {
    document.querySelectorAll('.giftreggie-no-products a:not([data-bjo]), .giftreggie-browse-add-products a:not([data-bjo])').forEach((a) => {
      a.dataset.bjo = '';
      a.textContent = isAr ? 'تصفّح وأضف' : 'Browse & Add';
    });
    // bottom buttons grouped like the header: Discard | Save on one row, Browse & Add under them, same total width
    const act = document.querySelector('.giftreggie-manager .action-buttons:not([data-bjo])');
    const browse = document.querySelector('.giftreggie-manager .giftreggie-browse-add-products');
    if (act && browse) {
      act.dataset.bjo = '';
      const foot = document.createElement('div');
      foot.className = 'bjo-owner-foot';
      act.before(foot);
      foot.append(act, browse);
    }
  };
  // Prices like the rest of the site: "JOD 319.000" → "319 JOD", "JOD 0.250" → "0.25 JOD"
  // Arabic pages get "‏٣١٩٫٠٠٠ د.أ.‏" (bidi marks, Arabic digits, ٫ decimal) → plain "319.000 د.أ." before parsing
  const normPrice = (s) => String(s).replace(/[\u200e\u200f\u061c\u202a-\u202e\u2066-\u2069]/g, '').trim()
    .replace(/[٠-٩]/g, (d) => d.charCodeAt(0) - 0x660).replace(/٫/g, '.').replace(/[,٬]/g, '');
  const priceFix = () => {
    document.querySelectorAll('.giftreggie-front gr-storefront-field:not([data-bjo-p])').forEach((el) => {
      const m = normPrice(el.textContent).match(/^(?:JOD\s*(\d+(?:\.\d+)?)|(\d+(?:\.\d+)?)\s*د\.أ\.?)$/);
      if (!m) return;
      el.dataset.bjoP = '';
      el.textContent = Number(m[1] || m[2]) + ' JOD';
    });
  };
  // Owner's Orders tab: the app's 7-column table → one card per order (who, when, order #, then what they bought)
  const ordersCards = () => {
    const t = document.querySelector('.giftreggie-front table.giftreggie-orders:not([data-bjo])');
    if (!t) return;
    t.dataset.bjo = '';
    const rows = [...t.querySelectorAll('tr')].filter((r) => r.querySelector('td'));
    if (!rows.length) return;
    const orders = new Map();
    rows.forEach((r) => {
      const c = [...r.children].map((td) => td.textContent.trim());
      const [num, date, user, email, item, price, qty] = c;
      if (!orders.has(num)) orders.set(num, { num, date, user, email, items: [] });
      orders.get(num).items.push({ item, price, qty });
    });
    const wrap = document.createElement('div');
    wrap.className = 'bjo-orders';
    orders.forEach((o) => {
      const card = document.createElement('div');
      card.className = 'bjo-order';
      card.innerHTML = '<div class="bjo-order__head"><b></b><span class="bjo-order__num"></span></div><div class="bjo-order__meta"></div><ul class="bjo-order__items"></ul>';
      card.querySelector('b').textContent = o.user || (isAr ? 'ضيف' : 'Guest');
      card.querySelector('.bjo-order__num').textContent = o.num;
      card.querySelector('.bjo-order__meta').textContent = [o.date, o.email].filter(Boolean).join(' · ');
      const ul = card.querySelector('ul');
      o.items.forEach((it) => {
        const li = document.createElement('li');
        li.innerHTML = '<span class="bjo-order__item"></span><span class="bjo-order__qty"></span>';
        li.firstChild.textContent = it.item;
        const n = normPrice(it.price).match(/\d+(?:\.\d+)?/);
        const p = n ? Number(n[0]) : NaN;
        li.lastChild.textContent = '× ' + (it.qty || 1) + (isNaN(p) ? '' : ' · ' + p + ' JOD');
        ul.append(li);
      });
      wrap.append(card);
    });
    t.style.display = 'none';
    t.after(wrap);
  };
  const tidyForm = () => {
    document.querySelectorAll('.giftreggie-front form select:not([data-bjo])').forEach((sel) => {
      sel.dataset.bjo = '';
      const real = [...sel.options].filter((o) => o.value && !/^n\/?a$/i.test(o.textContent.trim()));
      const row = sel.closest('p, div, tr, li');
      if (!real.length && row && row.querySelectorAll('select,input:not([type="hidden"]),textarea').length === 1 && /hear about us/i.test(row.textContent)) row.style.display = 'none';
    });
    // Fields Hamza doesn't need: evening phone (one phone is enough), province/state, postal code.
    ['registrant-title', 'coregistrant-title', 'contact-evening', 'contact-province', 'contact-postal', 'before-province', 'before-postal', 'after-province', 'after-postal'].forEach((n) => {
      const el = document.querySelector('.giftreggie-front form [name="' + n + '"]:not([data-bjo])');
      if (!el) return;
      el.dataset.bjo = '';
      const row = el.closest('p');
      if (row && row.querySelectorAll('input:not([type="hidden"]),select,textarea').length === 1) row.style.display = 'none';
    });
    const ev = document.querySelector('.giftreggie-front form [name="event-date"]:not([data-bjo])');
    if (ev) {
      ev.dataset.bjo = '';
      if (ev.value.trim() === NO_DATE) ev.value = '';
      const holder = ev.closest('span') || ev.closest('p');
      const w = document.createTreeWalker(holder, NodeFilter.SHOW_TEXT);
      let t;
      while ((t = w.nextNode())) if (/Event Date/i.test(t.nodeValue)) t.nodeValue = isAr ? 'تاريخ المناسبة (اختياري) ' : 'Event Date (optional) ';
    }
    // registry pages: hide the "no date" placeholder wherever the app prints it
    document.querySelectorAll('.giftreggie-front td:not([data-bjo-d]), .giftreggie-front p:not([data-bjo-d])').forEach((el) => {
      el.dataset.bjoD = '';
      if (el.children.length > 2 || !el.textContent.includes(NO_DATE)) return;
      if (el.tagName === 'TD') {
        const i = [...el.parentElement.children].indexOf(el);
        el.classList.add('bjo-hide');
        const head = el.closest('table')?.querySelector('tr');
        if (head && head !== el.parentElement && head.children[i]) head.children[i].classList.add('bjo-hide');
      } else el.classList.add('bjo-hide');
    });
    const day = document.querySelector('.giftreggie-front form [name="contact-daytime"]:not([data-bjo])');
    if (day) {
      day.dataset.bjo = '';
      day.type = 'tel';
      const w = document.createTreeWalker(day.closest('.registry-profile-block') || document.body, NodeFilter.SHOW_TEXT);
      let t;
      while ((t = w.nextNode())) if (t.nodeValue.trim() === 'Daytime Telephone') t.nodeValue = isAr ? 'رقم الهاتف' : 'Phone';
    }
    document.querySelectorAll('.giftreggie-front form input[type="checkbox"]:not([data-bjo])').forEach((box) => {
      box.dataset.bjo = '';
      const row = box.closest('p, div, li, td');
      // only a small row holding just this box (never a whole section)
      if (row && row.querySelectorAll('input:not([type="hidden"]),select,textarea').length === 1) {
        row.classList.add('bjo-check-row');
        // same green switch as gift wrap: a track right after the real checkbox (which stays in the form)
        // shorter wording so it fits one line, like the shipping switch
        [...row.childNodes].forEach((n) => {
          if (n.nodeType === 3 && /notification emails to registry managers/i.test(n.nodeValue)) n.nodeValue = isAr ? ' أرسل التحديثات لمديري السجل أيضاً' : ' Email updates to registry managers too';
        });
        if (!box.closest('.bjo-switch')) {
          const track = document.createElement('span');
          track.className = 'bjo-switch__track';
          track.setAttribute('aria-hidden', 'true');
          box.classList.add('bjo-switch__input');
          box.after(track);
          track.addEventListener('click', () => box.click());
        }
      }
    });
  };
  // Registry photo: one tidy upload box instead of "Registry Image / Choose File / no file selected / 5MB Max File Size".
  const tidyUpload = () => {
    const file = document.querySelector('.giftreggie-front input[type="file"]:not([data-bjo-up])');
    if (!file) return;
    file.dataset.bjoUp = '';
    const row = file.closest('p');
    const hint = row && row.nextElementSibling;
    const box = document.createElement('label');
    box.className = 'bjo-upload';
    const base = isAr ? 'أضف صورة (اختياري، حتى 5MB)' : 'Add a photo (optional, max 5MB)';
    box.innerHTML = '<svg class="bjo-upload__icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg><span class="bjo-upload__text"></span>';
    box.querySelector('.bjo-upload__text').textContent = base;
    row.before(box);
    box.append(file);
    row.style.display = 'none';
    if (hint && /max file size/i.test(hint.textContent)) hint.style.display = 'none';
    let preview = null;
    // Phone photos (3-10MB, often HEIC) make the save fail with "400 Missing … as parameters": the request is too big
    // to reach the app. Shrink the chosen photo in the browser first (max 1600px JPEG, ~200-500KB). (2026-10-10)
    const shrink = (f) => new Promise((done) => {
      if (!f || !f.type.startsWith('image/') || (f.size < 700 * 1024 && /jpe?g|png/.test(f.type))) return done(null);
      const img = new Image();
      img.onload = () => {
        const k = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
        const c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(img.src);
        c.toBlob((b) => done(b ? new File([b], f.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : null), 'image/jpeg', 0.85);
      };
      img.onerror = () => done(null);
      img.src = URL.createObjectURL(f);
    });
    file.addEventListener('change', async () => {
      const small = await shrink(file.files[0]);
      if (small && window.DataTransfer) { const dt = new DataTransfer(); dt.items.add(small); file.files = dt.files; }
      const f = file.files[0];
      box.querySelector('.bjo-upload__text').textContent = f ? '✓ ' + f.name : base;
      box.classList.toggle('has-file', !!f);
      // small preview of the chosen photo in place of the camera icon
      if (preview) { URL.revokeObjectURL(preview.src); preview.remove(); preview = null; }
      box.querySelector('.bjo-upload__icon').style.display = f ? 'none' : '';
      if (f && f.type.startsWith('image/')) {
        preview = document.createElement('img');
        preview.className = 'bjo-upload__preview';
        preview.alt = '';
        preview.src = URL.createObjectURL(f);
        box.prepend(preview);
      }
    });
  };

  // Shipping: one green switch "Send gifts to my address above" (on by default) instead of the
  // before-event / after-event pickers and two address blocks. Off = one address block, used for both.
  const FIELDS = ['address', 'city', 'province', 'country', 'postal'];
  const tidyShipping = () => {
    const before = document.getElementById('before-shipping-selector');
    if (!before || 'bjoShip' in before.dataset) return;
    before.dataset.bjoShip = '';
    const after = document.getElementById('after-shipping-selector');
    const form = before.form || before.closest('form');
    const block = before.closest('.registry-profile-block');
    const beforeBox = block.querySelector('.before-shipping');
    const field = (n) => form.querySelector('[name="' + n + '"]');
    const val = (n) => (field(n) ? field(n).value.trim() : '');
    before.closest('p').style.display = 'none';
    if (after) after.closest('span').style.display = 'none';
    // editing an existing registry that already ships somewhere else → start with the switch off
    const custom = before.value === 'below' || FIELDS.some((k) => k !== 'country' && val('before-' + k) && val('before-' + k) !== val('contact-' + k));
    const sw = document.createElement('label');
    sw.className = 'bjo-switch';
    sw.innerHTML = '<input type="checkbox"><span class="bjo-switch__track" aria-hidden="true"></span><span class="bjo-switch__label"></span>';
    sw.querySelector('.bjo-switch__label').textContent = isAr ? 'أرسل الهدايا إلى عنواني أعلاه' : 'Send gifts to my address above';
    const box = sw.querySelector('input');
    box.checked = !custom;
    (block.querySelector('h4') || block.firstElementChild).after(sw);
    const apply = () => {
      const same = box.checked;
      beforeBox.style.display = same ? 'none' : '';
      before.value = same ? 'above' : 'below';
      if (after) after.value = same ? 'above' : 'below';
      // the app listens for change: 'above' disables + empties the address fields, 'below' opens them for typing
      [before, after].forEach((sel) => sel && sel.dispatchEvent(new Event('change', { bubbles: true })));
    };
    box.addEventListener('change', apply);
    apply();
    // switch off = one address block: use it for after the event too
    form.addEventListener('submit', () => {
      if (box.checked) return;
      FIELDS.forEach((k) => { if (field('after-' + k)) field('after-' + k).value = val('before-' + k); });
    }, true);
  };

  // Registry page: each item gets the product-page quantity selector (1 … still-needed) + its own Add to Cart.
  // Adds straight to the cart with the registry tagged on the cart (registry_id — what the app itself sets),
  // so the purchase still counts against the registry, then shows the add-to-cart pop-up and stays on the page. The app's type-a-number box + "Update Cart" is hidden.
  const MINUS = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>';
  const PLUS = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';
  const regId = (location.pathname.match(/registry\/(\d+)/) || [])[1];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const post = (url, body) => fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  // same feedback as product pages: the button says "Added" (AR: تمت الإضافة) for 1.8s
  const saidAdded = (btn) => {
    if (btn.__bjoTxt) return;
    btn.__bjoTxt = btn.textContent;
    btn.textContent = isAr ? 'تمت الإضافة' : 'Added';
    btn.classList.add('bjo-reg-added');
    setTimeout(() => { btn.textContent = btn.__bjoTxt; btn.__bjoTxt = null; btn.classList.remove('bjo-reg-added'); }, 1800);
  };
  const saidNo = (btn, soldOut) => {   // the add was refused: sold out stays on the button; not enough stock comes back after a moment
    btn.__bjoNo = soldOut;
    const txt = btn.__bjoTxt || btn.textContent;
    btn.textContent = soldOut ? (isAr ? 'نفدت الكمية' : 'Sold out') : (isAr ? 'الكمية غير متوفرة' : 'Not enough stock');
    if (!soldOut) setTimeout(() => { btn.textContent = txt; }, 2200);
  };
  const refreshBubble = () => fetch(location.pathname + '?sections=cart-icon-bubble').then((r) => r.json()).then((s) => {
    const b = document.getElementById('cart-icon-bubble');
    if (b && s['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
  }).catch(() => {});
  const buyBox = (vid, appBtn) => {
    const wrap = document.createElement('div');
    wrap.className = 'bjo-reg-buy';
    wrap.dataset.vid = vid;
    wrap.innerHTML = '<quantity-input class="quantity bjo-reg-qty">'
      + '<button class="quantity__button" name="minus" type="button"><span class="visually-hidden">-</span><span class="svg-wrapper">' + MINUS + '</span></button>'
      + '<input class="quantity__input" type="number" value="1" min="1" step="1" data-min="1" aria-label="Quantity">'
      + '<button class="quantity__button" name="plus" type="button"><span class="visually-hidden">+</span><span class="svg-wrapper">' + PLUS + '</span></button>'
      + '</quantity-input><button type="button" class="bjo-reg-add"></button>';
    const btn = wrap.querySelector('.bjo-reg-add');
    const input = wrap.querySelector('.quantity__input');
    btn.textContent = isAr ? 'أضف للسلة' : 'Add to Cart';
    btn.addEventListener('click', async () => {
      const qty = Math.max(1, Math.min(parseInt(input.value, 10) || 1, parseInt(input.max, 10) || 999));
      btn.disabled = true;
      let added = false;
      try {
        if (regId) await post('cart/update.js', { attributes: { registry_id: regId } });
        const note = document.querySelector('cart-notification');
        const r = await post('cart/add.js', {
          items: [{ id: Number(vid), quantity: qty }],
          ...(note ? { sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: root } : {}),
        });
        if (!r.ok) throw new Error('add failed');
        added = true;
        const data = await r.json();
        if (wrapOn()) { try { await syncWrap(); } catch (e) {} }
        // stay on the registry (guests keep adding / pick gift wrap — Hamza 2026-10-14): cart number + "Added" on the button
        if (note && data.items && data.items[0] && data.sections) note.renderContents({ ...data.items[0], sections: data.sections });
        else refreshBubble();
        saidAdded(btn);
        input.value = 1;
      } catch (e) {
        if (added) saidAdded(btn); // already in the cart: never add twice, never leave the page
        else if (appBtn) appBtn.click(); // fall back to the app's own one-at-a-time button
      } finally {
        btn.disabled = false;
      }
    });
    return wrap;
  };
  // Guest registry: gift wrap for the whole order, same choices as the product page (Hamza 2026-10-10):
  // "Gift wrap? 0.3 JOD per item" switch → paper (Light / Christmas, the BambiniJO Gift Wrap variants), Receiver, Sender, Message.
  // One gift-wrap line in the cart sized to every item not already wrapped; kept in step after each Add to Cart and before Checkout.
  const WRAPS = [
    { id: 47682502656243, name: 'Light', ar: 'فاتح', img: 'https://cdn.shopify.com/s/files/1/0052/4392/8664/files/GIFTWRAPPING50X70TEXT2.jpg?v=1785615197&width=480' },
    { id: 46497685111027, name: 'Christmas', ar: 'كريسماس', img: 'https://cdn.shopify.com/s/files/1/0052/4392/8664/files/GIFTWRAPPING50X70NEW2_83f2987c-6351-432f-a5d5-1ec3c4013f4a.jpg?v=1785615151&width=480' },
  ];
  const WRAP_IDS = WRAPS.map((w) => w.id);
  const wst = () => { try { return JSON.parse(sessionStorage.getItem('bjoRegWrap2') || '{}'); } catch (e) { return {}; } };
  const wsave = (o) => { try { sessionStorage.setItem('bjoRegWrap2', JSON.stringify({ ...wst(), ...o })); } catch (e) {} };
  const wrapOn = () => !!wst().on;
  const syncWrap = async () => {
    const st = wst();
    const vid = st.vid || WRAPS[0].id;
    const cart = await (await fetch(root + 'cart.js')).json();
    const lines = cart.items.filter((i) => i.properties && i.properties._bjo_wrap === 'order');
    const need = st.on ? cart.items.filter((i) => !WRAP_IDS.includes(i.variant_id) && !(i.properties && i.properties['Gift Wrap'])).reduce((n, i) => n + i.quantity, 0) : 0;
    const props = { 'Gift Wrap': isAr ? 'الطلب كاملاً' : 'Entire order', 'Gift Option': (WRAPS.find((w) => w.id === vid) || WRAPS[0]).name, To: st.to || '', From: st.from || '', Message: st.msg || '', _bjo_wrap: 'order' };
    const same = (l) => l.variant_id === vid && l.quantity === need && ['To', 'From', 'Message'].every((k) => (l.properties[k] || '') === props[k]);
    if (lines.length === 1 && same(lines[0])) return;
    for (const l of lines) await post('cart/change.js', { id: l.key, quantity: 0 });
    if (need) await post('cart/add.js', { items: [{ id: vid, quantity: need, properties: props }] });
  };
  const wrapSwitch = () => {
    const act = document.querySelector('.giftreggie-front:not(.giftreggie-manager) .action-buttons:has(#giftreggie-checkout)');
    if (!act || document.querySelector('.bjo-reg-wrap')) return;
    const st = wst();
    const box = document.createElement('div');
    box.className = 'bjo-reg-wrapbox';
    box.innerHTML = '<label class="bjo-switch bjo-reg-wrap"><input type="checkbox"><span class="bjo-switch__track" aria-hidden="true"></span><span class="bjo-switch__label"></span></label>'
      + '<div class="bjo-reg-wrap__panel"><div class="bjo-reg-wrap__papers"></div>'
      + '<input type="text" class="bjo-reg-wrap__f" data-k="to" maxlength="60"><input type="text" class="bjo-reg-wrap__f" data-k="from" maxlength="60">'
      + '<textarea class="bjo-reg-wrap__f" data-k="msg" maxlength="250" rows="3"></textarea><div class="bjo-reg-wrap__count"><span class="bjo-reg-wrap__price"></span><span class="bjo-reg-wrap__left"></span></div></div>';
    box.querySelector('.bjo-switch__label').textContent = isAr ? 'تغليف الهدايا' : 'Gift Wrap';
    const [fTo, fFrom, fMsg] = box.querySelectorAll('.bjo-reg-wrap__f');
    fTo.placeholder = isAr ? 'المستلم' : 'Receiver';
    fFrom.placeholder = isAr ? 'المرسل' : 'Sender';
    fMsg.placeholder = isAr ? 'اتركها فارغة لبطاقة بدون كتابة، أو نكتب رسالتك بخط اليد' : "Leave empty for a blank card, or we'll hand-write your message for you";
    fTo.value = st.to || ''; fFrom.value = st.from || ''; fMsg.value = st.msg || '';
    // footer like the product page: price note left, "N left" only in the last 50 characters
    box.querySelector('.bjo-reg-wrap__price').textContent = isAr ? '\u20660.3 JOD\u2069 لكل قطعة' : '0.3 JOD per item';
    const leftEl = box.querySelector('.bjo-reg-wrap__left');
    const updLeft = () => { const n = 250 - fMsg.value.length; leftEl.textContent = n <= 50 ? (isAr ? 'متبقٍ ' + n : n + ' left') : ''; };
    updLeft();
    const papers = box.querySelector('.bjo-reg-wrap__papers');
    WRAPS.forEach((w) => {
      const l = document.createElement('label');
      l.className = 'bjo-reg-wrap__paper';
      l.innerHTML = '<input type="radio" name="bjo-reg-wrap-paper"><img alt="" loading="lazy"><span></span>';
      l.querySelector('img').src = w.img;
      l.querySelector('span').textContent = isAr ? w.ar : w.name;
      const r = l.querySelector('input');
      r.checked = (st.vid || WRAPS[0].id) === w.id;
      r.addEventListener('change', () => { wsave({ vid: w.id }); run(); });
      papers.append(l);
    });
    const cb = box.querySelector('.bjo-reg-wrap input');
    const show = () => box.classList.toggle('is-on', cb.checked);
    cb.checked = !!st.on; show();
    let busy = Promise.resolve();
    const run = () => { busy = busy.then(() => syncWrap()).catch(() => {}); return busy; };
    cb.addEventListener('change', () => { wsave({ on: cb.checked }); show(); run(); });
    [fTo, fFrom, fMsg].forEach((f) => {
      f.addEventListener('input', () => { wsave({ [f.dataset.k]: f.value }); if (f === fMsg) updLeft(); });
      f.addEventListener('change', run);
    });
    // Checkout (ours, not the app's): the app's button only buys what was typed in its own hidden boxes, so with an
    // empty cart it bounced to the home page. Now: nothing in the cart yet + a one-gift registry → add that gift at the
    // chosen quantity; several gifts → ask to add one first. Then the wrap line is brought up to date and we go to checkout.
    const co = act.querySelector('#giftreggie-checkout');
    const say = (t) => { let m = act.parentElement.querySelector('.bjo-reg-msg'); if (!m) { m = document.createElement('p'); m.className = 'bjo-reg-msg'; act.after(m); } m.textContent = t; };
    // capture on the document so we run before the app's own click handler, and stop it from ever seeing the click
    document.addEventListener('click', async (e) => {
      if (!e.target.closest || e.target.closest('#giftreggie-checkout') !== co) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (co.dataset.busy) return;
      co.dataset.busy = '1';
      try {
        const gifts = async () => (await (await fetch(root + 'cart.js')).json()).items.filter((i) => !WRAP_IDS.includes(i.variant_id));
        if (!(await gifts()).length) {
          const adds = [...document.querySelectorAll('.bjo-reg-add')].filter((b) => b.offsetParent);
          if (adds.length !== 1) { say(isAr ? 'أضف هدية إلى السلة أولاً' : 'Add a gift to your cart first'); return; }
          adds[0].click();
          for (let i = 0; i < 30 && !(await gifts()).length; i++) await new Promise((r) => setTimeout(r, 200));
          document.querySelector('cart-notification')?.close?.();
        }
        await run();
        location.href = root + 'checkout';
      } finally { delete co.dataset.busy; }
    }, true);
    act.before(box);
  };
  const rowButtons = () => {
    document.querySelectorAll('.giftreggie-front table.giftreggie-desktop tr.registry-variant:not([data-bjo])').forEach((tr) => {
      tr.dataset.bjo = '';
      const vid = tr.querySelector('.variant-id')?.value;
      const qty = tr.querySelector('.registry-variant-quantity');
      if (!vid || !qty) return;
      const li = [...document.querySelectorAll('.giftreggie-front ul.giftreggie-mobile li')].find((l) => l.querySelector('.variant-id')?.value === vid);
      qty.style.display = 'none';
      qty.after(buyBox(vid, li && li.querySelector('.giftreggie-add-to-cart')));
      const upd = document.getElementById('registry-update-cart');
      if (upd) upd.style.display = 'none';
    });
    document.querySelectorAll('.giftreggie-front ul.giftreggie-mobile li.registry-variant:not([data-bjo])').forEach((li) => {
      li.dataset.bjo = '';
      const vid = li.querySelector('.variant-id')?.value;
      const appBtn = li.querySelector('.giftreggie-add-to-cart');
      if (!vid || !appBtn || !regId) return;
      appBtn.style.display = 'none';
      appBtn.after(buyBox(vid, appBtn));
    });
  };

  // Registry page: instead of Line / Wants / Has / Needs numbers, one clear status per item.
  // Still needed → "Still needed" (or "2 of 3 still needed") + Add to Cart.
  // Fully bought → greyed, crossed out, "✓ Gifted", no button, moved to the bottom.
  const T = isAr
    ? { needs: (n) => 'مطلوب ' + n, done: '✓ تم إهداؤه' }
    : { needs: (n) => 'Needs ' + n, done: '✓ Gifted' };
  const pill = (needs, wants) => {
    const el = document.createElement('span');
    el.className = 'bjo-pill' + (needs <= 0 ? ' bjo-pill--gifted' : '');
    el.textContent = needs <= 0 ? T.done : T.needs(needs);
    return el;
  };
  const num = (el) => parseInt((el && el.textContent) || '', 10);
  const registryStatus = () => {
    const table = [...document.querySelectorAll('.giftreggie-front table.giftreggie-desktop:not([data-bjo-st])')].find((t) => t.querySelector('tr.registry-variant'));
    if (table) {
      table.dataset.bjoSt = '';
      const head = [...table.querySelectorAll('tr')].find((r) => r.querySelector('th'));
      const names = head ? [...head.children].map((c) => c.textContent.trim().toLowerCase()) : [];
      const col = (re) => names.findIndex((n) => re.test(n));
      const iLine = col(/^line$/), iWant = col(/^wants?$|المطلوب/), iHas = col(/^has$|تم شراؤه/), iNeed = col(/^needs?$/);
      const owner = !!table.closest('.giftreggie-manager');
      if (iWant >= 0 && iNeed >= 0) {
        // owner keeps the Wants column (it's where they set how many they want) — shown as a quantity selector
        [iLine, owner ? -1 : iWant, iHas, iNeed].filter((i) => i >= 0).forEach((i) => table.querySelectorAll('tr').forEach((r) => r.children[i] && r.children[i].classList.add('bjo-hide')));
        if (owner && head && head.children[iWant]) head.children[iWant].textContent = isAr ? 'الكمية' : 'Quantity';
        const gifted = [];
        table.querySelectorAll('tr.registry-variant').forEach((tr) => {
          const wants = num(tr.children[iWant]);
          const needs = iNeed >= 0 ? num(tr.children[iNeed]) : wants - num(tr.children[iHas]);
          if (isNaN(needs)) return;
          const cart = tr.lastElementChild;
          if (owner) {
            const has = wants - needs;
            if (has > 0) { const g = pill(0, wants); g.textContent = isAr ? '✓ تم إهداء ' + has : '✓ ' + has + ' gifted'; tr.children[iWant].append(g); }
            return;
          }
          cart.prepend(pill(needs, wants));
          const q = cart.querySelector('.quantity__input');
          if (q) q.max = Math.max(needs, 1);
          if (needs <= 0) {
            tr.classList.add('bjo-gifted');
            cart.querySelectorAll('button, input, .bjo-reg-buy').forEach((b) => (b.style.display = 'none'));
            gifted.push(tr);
          }
        });
        gifted.forEach((tr) => {
          const tag = tr.previousElementSibling && tr.previousElementSibling.matches('input[name="item-id"]') ? tr.previousElementSibling : null;
          const body = tr.parentElement;
          if (tag) body.append(tag);
          body.append(tr);
        });
      }
    }
    document.querySelectorAll('.giftreggie-front:not(.giftreggie-manager) ul.giftreggie-mobile li.registry-variant:not([data-bjo-st])').forEach((li) => {
      li.dataset.bjoSt = '';
      const t = li.querySelector('table');
      const needsTd = li.querySelector('.giftreggie-needs-quantity');
      if (!t || !needsTd) return;
      const tds = [...t.querySelectorAll('td')];
      const wants = num(tds[0]), needs = num(needsTd);
      if (isNaN(needs)) return;
      t.style.display = 'none';
      const btn = li.querySelector('.giftreggie-add-to-cart');
      (btn ? btn.parentElement : li).append(pill(needs, wants));
      const q = li.querySelector('.quantity__input');
      if (q) q.max = Math.max(needs, 1);
      if (needs <= 0) {
        li.classList.add('bjo-gifted');
        if (btn) btn.style.display = 'none';
        li.querySelectorAll('.bjo-reg-buy').forEach((b) => (b.style.display = 'none'));
        li.parentElement.append(li);
      }
    });
  };

  // Create / edit form checks: our own friendly message under the field (red outline, jump to it) instead of
  // the app's old pop-up. Postal code / province are hidden (Jordan doesn't use them) but the app still demands
  // a postal code, so an empty one is sent as 00000.
  const REQUIRED = isAr
    ? { 'registry-title': 'أضف اسماً للسجل', 'registrant-first': 'أضف اسمك الأول', 'registrant-last': 'أضف اسم العائلة', 'contact-address': 'أضف عنوانك', 'contact-city': 'أضف المدينة', 'contact-country': 'اختر الدولة' }
    : { 'registry-title': 'Give your registry a name', 'registrant-first': 'Add your first name', 'registrant-last': 'Add your last name', 'contact-address': 'Add your address', 'contact-city': 'Add your city', 'contact-country': 'Choose your country' };
  const clearErr = (el) => { el.classList.remove('bjo-invalid'); const m = el.parentElement.querySelector('.bjo-err'); if (m) m.remove(); };
  document.addEventListener('input', (e) => { if (e.target.classList && e.target.classList.contains('bjo-invalid')) clearErr(e.target); }, true);
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.querySelector || !form.querySelector('[name="registry-title"]')) return;
    // event date is optional for us, but the app demands a future date: an empty box is sent as NO_DATE,
    // which registry pages then hide (and the edit form shows as empty again)
    ['contact-postal', 'before-postal', 'after-postal'].forEach((n) => {
      const f = form.querySelector('[name="' + n + '"]');
      if (f && !f.disabled && !f.value.trim()) f.value = '00000';
    });
    let first = null;
    Object.entries(REQUIRED).forEach(([name, msg]) => {
      const f = form.querySelector('[name="' + name + '"]');
      if (!f) return;
      clearErr(f);
      if (f.value.trim()) return;
      f.classList.add('bjo-invalid');
      const m = document.createElement('span');
      m.className = 'bjo-err';
      m.textContent = msg;
      f.after(m);
      first = first || f;
    });
    const date = form.querySelector('[name="event-date"]');
    if (!first && date && !date.value.trim()) date.value = NO_DATE; // only once everything else is filled in
    if (first) {
      e.preventDefault();
      e.stopImmediatePropagation();
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => first.focus({ preventScroll: true }), 350);
    }
  }, true);

  // Owner's registry: the "wants" number box becomes the product-page quantity selector (same input, so Save works),
  // Save = dark main button, Discard / Edit Message = light, anything "Delete" = red outline, remove × = trash icon.
  const TRASH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';
  // Owner's registry on phones: quantity selector + trash icon in one row (was a Wants/Has/Needs table, no remove).
  // The phone and computer lists are the same form with two inputs per item, so keep their numbers in sync.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t.classList || !t.classList.contains('giftreggie-want-quantity')) return;
    document.querySelectorAll('input[name="' + t.name + '"]').forEach((i) => { if (i !== t) i.value = t.value; });
  }, true);
  const ownerMobile = () => {
    document.querySelectorAll('.giftreggie-manager ul.giftreggie-mobile li.registry-variant:not([data-bjo-om])').forEach((li) => {
      const q = li.querySelector('.bjo-reg-qty');
      const table = li.querySelector('table');
      if (!q || !table) return;
      li.dataset.bjoOm = '';
      const tds = [...table.querySelectorAll('td')];
      const has = parseInt((tds[1] && tds[1].textContent) || '0', 10) || 0;
      const row = document.createElement('div');
      row.className = 'bjo-owner-row';
      row.append(q);
      const id = li.querySelector('input[name="item-id"]')?.value;
      const tag = id && [...document.querySelectorAll('table.giftreggie-view-registry input[name="item-id"]')].find((i) => i.value === id);
      const del = tag && tag.nextElementSibling && tag.nextElementSibling.querySelector('button[name="action"]');
      if (del) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bjo-remove';
        b.setAttribute('aria-label', isAr ? 'إزالة' : 'Remove');
        b.innerHTML = TRASH;
        b.addEventListener('click', () => del.click());
        row.append(b);
      }
      if (has > 0) { const g = pill(0, 1); g.textContent = isAr ? '✓ تم إهداء ' + has : '✓ ' + has + ' gifted'; row.append(g); }
      table.after(row);
      table.style.display = 'none';
    });
  };

  // Phone registry items: price right under the name, then Needs + quantity + Add to Cart on one line
  const mobileItems = () => {
    document.querySelectorAll('.giftreggie-front:not(.giftreggie-manager) ul.giftreggie-mobile li.registry-variant:not([data-bjo-ml])').forEach((li) => {
      const buy = li.querySelector('.bjo-reg-buy');
      const pillEl = li.querySelector('.bjo-pill');
      if (!buy || !pillEl) return; // wait until both are in place
      li.dataset.bjoMl = '';
      const price = li.querySelector('gr-storefront-field[data-field="variant.price"]');
      const name = li.querySelector('.giftreggie-item-name');
      if (price && name) {
        const pp = document.createElement('p');
        pp.className = 'bjo-m-price';
        pp.append(price);
        name.closest('p').after(pp);
      }
      buy.prepend(pillEl);
      li.classList.add('bjo-m-item');
    });
  };

  // Phone summary ("Registrant: Dima Ahmad"…) → one soft card, label on one side, value on the other
  const summaryRows = () => {
    document.querySelectorAll('.giftreggie-registry-summary .giftreggie-mobile p:not([data-bjo-s])').forEach((p) => {
      p.dataset.bjoS = '';
      const first = p.firstChild;
      if (!first || first.nodeType !== 3) return;
      const m = first.nodeValue.match(/^\s*([^:]+):\s*(.*)$/);
      if (!m) return;
      const lbl = document.createElement('span');
      lbl.className = 'bjo-lbl';
      lbl.textContent = m[1];
      first.nodeValue = m[2];
      const val = document.createElement('span');
      while (p.firstChild) val.append(p.firstChild);
      p.append(lbl, val);
    });
  };

  // Owner's registry: "Copy Registry Link" right under the tabs (no need to open the Share tab)
  const ownerShare = () => {
    const menu = document.querySelector('.giftreggie-manager #giftreggie-admin-menu:not([data-bjo])');
    if (!menu || !regId) return;
    menu.dataset.bjo = '';
    // tabs: Share isn't needed any more (buttons below); "Profile" → "Settings"
    menu.querySelectorAll('li').forEach((li) => {
      const a = li.querySelector('a');
      const t = a ? a.textContent.trim() : '';
      if (/^share$|^مشاركة$/i.test(t) && !li.classList.contains('active')) li.remove();
      // tab names that say what they open (Hamza 2026-10-10: "Edit and Settings feel the same")
      if (/^profile$|^الملف$|^الإعدادات$|^settings$/i.test(t)) a.textContent = isAr ? 'التفاصيل' : 'Details';
      if (/^edit$|^تعديل$/i.test(t)) a.textContent = isAr ? 'قائمة الهدايا' : 'Gift List';
    });
    const url = location.origin + root + 'apps/giftregistry/registry/' + regId;
    const row = document.createElement('div');
    row.className = 'bjo-owner-share';
    row.innerHTML = '<button type="button" class="bjo-copy"></button>';
    const copy = row.querySelector('.bjo-copy');
    const copyLabel = isAr ? 'نسخ رابط السجل' : 'Copy Registry Link';
    copy.textContent = copyLabel;
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(url); } catch (e) { window.prompt('', url); return; }
      copy.textContent = isAr ? '✓ تم نسخ الرابط' : '✓ Link Copied';
      setTimeout(() => { copy.textContent = copyLabel; }, 2000);
    });
    // Copy link on top of Edit / Settings / Orders, exactly as wide as the three tabs (Hamza 2026-10-10)
    const head = document.createElement('div');
    head.className = 'bjo-owner-head';
    menu.before(head);
    head.append(row, menu);
  };

  const ownerTools = () => {
    document.querySelectorAll('.giftreggie-manager input.giftreggie-want-quantity:not([data-bjo])').forEach((inp) => {
      // rebuilt from HTML so the theme's quantity-input wires up its − / + buttons (same name + value, so Save still works)
      const holder = document.createElement('div');
      holder.innerHTML = '<quantity-input class="quantity bjo-reg-qty">'
        + '<button class="quantity__button" name="minus" type="button"><span class="visually-hidden">-</span><span class="svg-wrapper">' + MINUS + '</span></button>'
        + '<input class="quantity__input giftreggie-want-quantity" type="number" min="1" step="1" data-min="1" data-bjo="">'
        + '<button class="quantity__button" name="plus" type="button"><span class="visually-hidden">+</span><span class="svg-wrapper">' + PLUS + '</span></button></quantity-input>';
      const fresh = holder.querySelector('input');
      fresh.name = inp.name;
      fresh.value = inp.value || '1';
      fresh.setAttribute('aria-label', isAr ? 'الكمية' : 'Quantity');
      inp.replaceWith(holder.firstElementChild);
    });
    document.querySelectorAll('.giftreggie-manager button[name="action"]:not([data-bjo])').forEach((b) => {
      b.dataset.bjo = '';
      if (b.textContent.trim() !== '×') return;
      b.classList.add('bjo-remove');
      b.setAttribute('aria-label', isAr ? 'إزالة' : 'Remove');
      b.innerHTML = TRASH;
    });
    document.querySelectorAll('.giftreggie-front button:not([data-bjo-role]), .giftreggie-front input[type="submit"]:not([data-bjo-role])').forEach((b) => {
      b.dataset.bjoRole = '';
      const t = (b.tagName === 'INPUT' ? b.value : b.textContent).trim();
      if (b.id === 'save-changes') b.classList.add('bjo-primary');
      else if (/^delete\b/i.test(t) && !b.closest('table, ul')) b.classList.add('bjo-danger');
      else if (b.id === 'discard-changes' || /edit message|remove image/i.test(t)) b.classList.add('bjo-secondary');
    });
  };

  // Wishlist: the product-page quantity selector above each Add to Cart; adding shows the pop-up and stays on the page.
  const wishlistQty = () => {
    document.querySelectorAll('.giftreggie-wishlist form[action*="/cart/add"]:not([data-bjo])').forEach((form) => {
      form.dataset.bjo = '';
      const btn = form.querySelector('button[name="id"]');
      if (!btn) return;
      const holder = document.createElement('div');
      holder.innerHTML = '<quantity-input class="quantity bjo-reg-qty">'
        + '<button class="quantity__button" name="minus" type="button"><span class="visually-hidden">-</span><span class="svg-wrapper">' + MINUS + '</span></button>'
        + '<input class="quantity__input" type="number" name="quantity" value="1" min="1" step="1" data-min="1">'
        + '<button class="quantity__button" name="plus" type="button"><span class="visually-hidden">+</span><span class="svg-wrapper">' + PLUS + '</span></button></quantity-input>';
      holder.querySelector('input').setAttribute('aria-label', isAr ? 'الكمية' : 'Quantity');
      form.classList.add('bjo-reg-buy');
      const qtyInput = holder.querySelector('input');
      if (!form.id) form.id = 'bjo-wl-' + btn.value + '-' + Math.random().toString(36).slice(2, 7);
      qtyInput.setAttribute('form', form.id); // still sent with this form if the selector moves to its own column
      btn.before(holder.firstElementChild);
      form.addEventListener('submit', async (e) => {
        const note = document.querySelector('cart-notification');
        e.preventDefault();
        const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        btn.disabled = true;
        let added = false, r = null;
        try {
          r = await post('cart/add.js', { items: [{ id: Number(btn.value), quantity: qty }], sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: root });
          if (!r.ok) throw new Error('add failed');
          added = true;
          const data = await r.json();
          if (note) note.renderContents({ ...data.items[0], sections: data.sections }); else refreshBubble();
          saidAdded(btn);
          qtyInput.value = 1;
        } catch (err) {
          // never add twice and never leave the page once it's in. Shopify said no (sold out / not enough stock):
          // say so on the button and stay here (a plain form post lands on Shopify's error page, Hamza 2026-10-23).
          // Only a network failure (no answer at all) falls back to the normal form post.
          if (added) saidAdded(btn);
          else if (r) { const j = await r.json().catch(() => ({})); saidNo(btn, /sold out/i.test(j.description || j.message || '')); }
          else form.submit();
        } finally {
          btn.disabled = !!btn.__bjoNo;
        }
      });
    });
  };

  // Wishlist + registry: sold-out items say so before anyone taps Add to Cart (Hamza 2026-10-23: "show sold out before
  // they press add to cart? … same for registry, just the whole thing"). Availability from /products/<handle>.js.
  const avail = {};
  const soldOutMarks = () => {
    document.querySelectorAll('.giftreggie-front .bjo-reg-buy:not([data-bjo-av])').forEach(async (box) => {
      box.dataset.bjoAv = '';
      const btn = box.querySelector('.bjo-reg-add, button[name="id"]');
      const vid = Number(box.dataset.vid || (btn && btn.value));
      const a = box.closest('tr, li')?.querySelector('a[href*="/products/"]');
      const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!btn || !vid || !m) return;
      try {
        avail[m[1]] = avail[m[1]] || fetch('/products/' + m[1] + '.js').then((r) => (r.ok ? r.json() : null));
        const prod = await avail[m[1]];
        const v = prod && prod.variants.find((x) => x.id === vid);
        if (!v || v.available) return;
        saidNo(btn, true);
        btn.disabled = true;
        box.classList.add('bjo-reg-soldout');
        const q = box.querySelector('.bjo-reg-qty');
        if (q) q.style.display = 'none';
      } catch (e) {}
    });
  };

  // Arabic: product names come from the app in English — swap in the store's Arabic title (from /ar/products/<handle>.js)
  const arTitles = () => {
    if (!isAr) return;
    const els = [...document.querySelectorAll('.giftreggie-front gr-storefront-field[data-field="variant.fullTitle"]:not([data-bjo-ar])')];
    if (!els.length) return;
    const byHandle = {};
    els.forEach((el) => {
      el.dataset.bjoAr = '';
      const a = el.closest('a[href*="/products/"]');
      const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) (byHandle[m[1]] = byHandle[m[1]] || []).push(el);
    });
    Object.entries(byHandle).forEach(async ([handle, list]) => {
      try {
        const key = 'bjo-ar-' + handle;
        let prod = null;
        try { prod = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
        if (!prod) {
          const r = await fetch('/ar/products/' + handle + '.js');
          if (!r.ok) return;
          const j = await r.json();
          prod = { title: j.title, variants: j.variants.map((v) => [String(v.id), v.public_title]) };
          try { sessionStorage.setItem(key, JSON.stringify(prod)); } catch (e) {}
        }
        list.forEach((el) => {
          const v = prod.variants.find((x) => x[0] === String(el.dataset.variantId));
          el.textContent = prod.title + (v && v[1] ? ' | ' + v[1] : '');
        });
      } catch (e) {}
    });
  };

  // Computer tables: the quantity selector gets its own "Quantity" column before Cart
  const qtyColumn = () => {
    document.querySelectorAll('.giftreggie-front table.giftreggie-desktop.giftreggie-view-registry:not([data-bjo-qc])').forEach((table) => {
      if (table.querySelector('input.giftreggie-want-quantity')) return; // owner's registry: its Quantity column already exists
      const firstQty = table.querySelector('tr.registry-variant .bjo-reg-qty');
      const head = [...table.querySelectorAll('tr')].find((r) => r.querySelector('th'));
      if (!firstQty || !head) return;
      // rows can carry extra hidden cells, so place the header by the Cart heading (last column if not found)
      const cartTh = [...head.children].find((c) => /^cart$|السلة/i.test(c.textContent.trim())) || head.lastElementChild;
      table.dataset.bjoQc = '';
      const th = document.createElement('th');
      th.textContent = isAr ? 'الكمية' : 'Quantity';
      head.insertBefore(th, cartTh);
      table.querySelectorAll('tr.registry-variant').forEach((tr) => {
        const q = tr.querySelector('.bjo-reg-qty');
        const cell = q && q.closest('td');
        if (!cell) return;
        const td = document.createElement('td');
        td.className = 'bjo-qty-cell';
        cell.querySelectorAll('.bjo-pill').forEach((el) => td.append(el));
        td.append(q);
        tr.insertBefore(td, cell);
      });
    });
  };

  // Any registry / wishlist table: photo column first, then the name
  const imageFirst = () => {
    document.querySelectorAll('.giftreggie-front table.giftreggie-view-registry:not([data-bjo-img])').forEach((table) => {
      table.dataset.bjoImg = '';
      const head = [...table.querySelectorAll('tr')].find((r) => r.querySelector('th'));
      if (!head) return;
      const names = [...head.children].map((c) => c.textContent.trim().toLowerCase());
      const iImg = names.findIndex((n) => /^image$|الصورة/.test(n)), iTitle = names.findIndex((n) => /^title$|المنتج|العنوان/.test(n));
      if (iImg > iTitle && iTitle >= 0) table.querySelectorAll('tr').forEach((r) => { const c = r.children; if (c[iImg] && c[iTitle]) r.insertBefore(c[iImg], c[iTitle]); });
    });
  };

  // Batched to one run per frame, and capped so a page that keeps redrawing can never lock up.
  let runs = 0, queued = false;
  const tick = () => {
    queued = false;
    if (++runs > 60) return observer.disconnect();
    addShare(); tidyForm(); coReg(); manageLink(); browseBtn(); wrapSwitch(); priceFix(); ordersCards(); tidyUpload(); tidyShipping(); rowButtons(); registryStatus(); imageFirst(); wishlistQty(); soldOutMarks(); qtyColumn(); arTitles(); ownerTools(); ownerShare(); ownerMobile(); summaryRows(); mobileItems();
  };
  const observer = new MutationObserver(() => { if (!queued) { queued = true; requestAnimationFrame(tick); } });
  tick();
  observer.observe(document.body, { childList: true, subtree: true });
  // show the registry only once it's been tidied (base.css keeps .giftreggie-front invisible until then), so the app's
  // raw titles / old trash icons never flash on refresh
  const reveal = () => setTimeout(() => document.documentElement.classList.add('bjo-reg-ready'), 0);
  if (!isAr) reveal();
  window.__bjoRegistryRuns = () => runs;
  if (!isAr) return;
  const AR = {
    'Welcome to our Gift Registry!': 'أهلاً بك في سجل الهدايا!',
    'Find >': 'ابحث ‹', 'Find a registry.': 'ابحث عن سجل.',
    'Create >': 'أنشئ ‹', 'Create a registry.': 'أنشئ سجلاً جديداً.',
    'Manage >': 'إدارة ‹', 'Manage an existing registry.': 'إدارة سجل موجود.',
    'Find a Gift Registry': 'ابحث عن سجل هدايا',
    'Enter a first or last name below to quickly locate a registry.': 'اكتب الاسم الأول أو اسم العائلة للعثور على السجل بسرعة.',
    'First Name': 'الاسم الأول', 'Last Name': 'اسم العائلة', 'Find': 'ابحث',
    "You aren't logged in. You can view and purchase off of existing registries, but you cannot create new ones. If you'd like to create one, please log in.":
      'لم تسجّل الدخول بعد. يمكنك تصفّح السجلات الموجودة والشراء منها، ولإنشاء سجل جديد يرجى تسجيل الدخول.',
    "You're not logged in! To activate a wishlist, please": 'لم تسجّل الدخول بعد! لتفعيل قائمة الرغبات، يرجى',
    'register': 'إنشاء حساب', ', or': ' أو ', 'login': 'تسجيل الدخول',
    // common signed-in phrases (harmless if the app never shows them)
    'Create a Gift Registry': 'أنشئ سجل هدايا', 'Manage Registry': 'إدارة السجل', 'My Wishlist': 'قائمة رغباتي',
    'Wishlist': 'قائمة الرغبات', 'Gift Registry': 'سجل الهدايا', 'Add to Cart': 'أضف للسلة', 'Quantity': 'الكمية',
    'Wants': 'المطلوب', 'Wanted': 'المطلوب', 'Has': 'تم شراؤه', 'Purchased': 'تم شراؤه', 'Remaining': 'المتبقي',
    'Price': 'السعر', 'Product': 'المنتج', 'Save': 'حفظ', 'Delete': 'حذف', 'Remove': 'إزالة', 'Share': 'مشاركة',
    'Update': 'تحديث', 'Submit': 'إرسال', 'Search': 'بحث', 'Back': 'رجوع', 'Cancel': 'إلغاء',
    'Event Date': 'تاريخ المناسبة', 'Registry Name': 'اسم السجل', 'Title': 'المنتج', 'Description': 'الوصف',
    'Email': 'البريد الإلكتروني', 'Phone': 'رقم الهاتف', 'Address': 'العنوان', 'City': 'المدينة', 'Country': 'الدولة',
    'Your wishlist is empty.': 'قائمة رغباتك فارغة.',
    'There are no orders associated with this registry.': 'لا توجد طلبات على هذا السجل بعد.', 'Update Profile': 'حفظ الإعدادات',
    'Remove Image': 'إزالة الصورة', 'Settings': 'الإعدادات',
    'Manage Registries': 'إدارة السجلات', 'To create a new registry, click here.': 'أنشئ سجلاً جديداً',
    'To manage one of your registries, click the registry name below.': 'اختر السجل الذي تريد إدارته:',
    'Registry Home': 'صفحة السجل', 'Edit': 'تعديل', 'Profile': 'الإعدادات', 'Orders': 'الطلبات', 'Edit Message': 'تعديل الرسالة',
    'Save Changes': 'حفظ التغييرات', 'Registrant': 'صاحب السجل', 'Co-Registrant': 'الشريك', 'Created': 'تاريخ الإنشاء',
    'Status': 'الحالة', 'Items': 'المنتجات', 'Value': 'القيمة', 'Open': 'مفتوح', 'None': 'لا يوجد', 'Name': 'الاسم',
    'Create your Registry': 'أنشئ سجل الهدايا', 'Complete the following information to create your gift registry.': 'أكمل المعلومات التالية لإنشاء سجل الهدايا.',
    'Already have a registry? Click here to manage it.': 'لديك سجل بالفعل؟ اضغط هنا لإدارته.', 'Registry Profile': 'ملف السجل',
    'Registry Title': 'اسم السجل', 'Public Message to Friends and Family': 'رسالة للأهل والأصدقاء',
    'Registrant Information': 'معلومات صاحب السجل', 'Co-Registrant Information': 'معلومات الشريك', 'Contact Information': 'معلومات التواصل',
    'Shipping Information': 'معلومات الشحن', 'Province/State': 'المحافظة', 'Zip/Postal Code': 'الرمز البريدي',
    'Daytime Telephone': 'هاتف (نهاراً)', 'Evening Telephone': 'هاتف (مساءً)', 'Verify Email': 'تأكيد البريد الإلكتروني',
    'Create My Registry': 'أنشئ سجلي', 'Discard Changes': 'تجاهل التغييرات',
    'Send notification emails to registry managers (in addition to contact email)': 'أرسل إشعارات إلى مديري السجل (بالإضافة إلى بريد التواصل)',
    'Image': 'الصورة', 'Cart': 'السلة', 'Delete Wishlist': 'حذف قائمة الرغبات', 'Delete Registry': 'حذف السجل',
    'Click here to begin browsing to add products to this wishlist.': 'تصفّح المنتجات وأضفها إلى قائمة الرغبات',
    'Click here to begin browsing to add products to this registry.': 'تصفّح المنتجات وأضفها إلى السجل',
  };
  const OWNER = [[/^Registrant: (.+)$/, 'صاحب السجل: $1'], [/^(.+?)[’']s Wishlist$/, 'قائمة رغبات $1'], [/^(.+?)[’']s Gift Registry$/, 'سجل هدايا $1'], [/^(.+?)[’']s Registry$/, 'سجل $1']];
  const swapText = (n) => {
    const t = n.nodeValue.trim();
    if (AR[t]) return (n.nodeValue = n.nodeValue.replace(t, AR[t]));
    for (const [re, to] of OWNER) if (re.test(t)) return (n.nodeValue = n.nodeValue.replace(t, t.replace(re, to)));
  };
  const run = (root) => {
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = w.nextNode())) if (!n.parentElement.closest('script,style')) swapText(n);
    root.querySelectorAll('input[type="submit"],input[type="button"],input[placeholder],textarea[placeholder]').forEach((i) => {
      if ((i.type === 'submit' || i.type === 'button') && AR[i.value.trim()]) i.value = AR[i.value.trim()];
      if (i.placeholder && AR[i.placeholder.trim()]) i.placeholder = AR[i.placeholder.trim()];
      if (i.placeholder === 'DD/MM/YYYY') i.placeholder = 'يوم/شهر/سنة';
      const l = i.getAttribute('aria-label');
      if (l && AR[l.trim()]) i.setAttribute('aria-label', AR[l.trim()]);
    });
  };
  let arRuns = 0, arQueued = false;
  const all = () => { arQueued = false; if (++arRuns > 60) return; document.querySelectorAll('.giftreggie-front').forEach(run); };
  all();
  reveal();
  new MutationObserver(() => { if (!arQueued) { arQueued = true; requestAnimationFrame(all); } }).observe(document.body, { childList: true, subtree: true });
})();
